/**
 * Staff Navigation
 * Navigation for condo staff (porteiro, sindico, zelador, etc.)
 * Limited to operational tasks within their assigned condo
 * Only includes pages with real functionality
 */

import { NavGroup } from './types';

export function getStaffNavigation(customer?: { porteiro_reports_enabled?: boolean } | null): NavGroup[] {
  return [
    {
      group: 'Operacional',
      icon: 'Activity',
      items: [
        { name: 'Controle de Acesso', href: '/access-control', icon: 'Shield' },
        { name: 'Eventos Gerais', href: '/eventos-gerais', icon: 'Activity' },
        ...(customer?.porteiro_reports_enabled
          ? [{ name: 'Relatórios', href: '/reports', icon: 'BarChart3' }]
          : []),
      ],
    },
    {
      group: 'Pessoas',
      icon: 'Users',
      items: [
        { name: 'Pessoas', href: '/people', icon: 'Users' },
        { name: 'Visitantes', href: '/visitors', icon: 'UserPlus' },
      ],
    },
    {
      group: 'Ajuda',
      icon: 'HelpCircle',
      items: [
        { name: 'Central de Ajuda', href: '/support', icon: 'Book' },
      ],
    },
  ];
}

// Backward-compat alias (in case any file imports STAFF_NAVIGATION directly)
export const STAFF_NAVIGATION = getStaffNavigation();
